import React from "react";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { SnackbarContent } from "@mui/material";
const SnackBarComponent = ({ message, open, handleClose, type }) => {
  const action = (
    <React.Fragment>
      <Button color="secondary" size="small" onClick={handleClose}></Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <>
      {open && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={open}
          autoHideDuration={1500}
          onClose={handleClose}
          message={message}
          action={action}
          sx={{ color: "green" }}
        >
          <SnackbarContent
            style={{
              backgroundColor:
                type === "Error"
                  ? "red"
                  : type === "Success"
                  ? "blue"
                  : "yellow",
            }}
            message={<span id="client-snackbar">{message}</span>}
          />
        </Snackbar>
      )}
    </>
  );
};

export default SnackBarComponent;